(() => {
  const root = document.querySelector('[data-your-kip]');
  if (!root) return;
  const labels = Object.fromEntries([...root.querySelector('[data-yk-labels]').content.querySelectorAll('[data-key]')].map(el => [el.dataset.key, el.textContent]));
  const video = root.querySelector('[data-yk-film]');
  const toggle = root.querySelector('[data-film-toggle]');
  const filmLabel = root.querySelector('[data-film-label]');
  const filmIcon = root.querySelector('[data-film-icon]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let userPaused = false;
  let inView = false;
  const setFilmState = () => {
    if (!video || !toggle) return;
    const playing = !video.paused;
    toggle.setAttribute('aria-pressed', String(playing));
    toggle.setAttribute('aria-label', playing ? labels.pause_aria : labels.play_aria);
    if (filmLabel) filmLabel.textContent = playing ? labels.pause : labels.play;
    filmIcon?.setAttribute('d', playing ? 'M5 4h3v12H5zM12 4h3v12h-3z' : 'M7 4l9 6-9 6z');
  };
  const tryPlay = () => video?.play().catch(() => setFilmState());
  video?.addEventListener('play', setFilmState);
  video?.addEventListener('pause', setFilmState);
  toggle?.addEventListener('click', () => {
    if (!video) return;
    if (video.paused) { userPaused = false; tryPlay(); }
    else { userPaused = true; video.pause(); }
  });
  if (video && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      if (inView && !userPaused && !reduced.matches && !navigator.connection?.saveData) tryPlay();
      else video.pause();
    }, {threshold: .2}).observe(video);
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) video?.pause();
    else if (inView && !userPaused && !reduced.matches && !navigator.connection?.saveData) tryPlay();
  });
  reduced.addEventListener('change', () => { if (reduced.matches) video?.pause(); });
  const sectionLinks = [...root.querySelectorAll('[data-section-link]')];
  const sections = sectionLinks.map(a => root.querySelector(a.getAttribute('href'))).filter(Boolean);
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      const active = entries.find(e => e.isIntersecting);
      if (!active) return;
      sectionLinks.forEach(a => {
        if (a.hash === '#' + active.target.id) a.setAttribute('aria-current', 'location');
        else a.removeAttribute('aria-current');
      });
    }, {rootMargin:'-15% 0px -60% 0px', threshold:0});
    sections.forEach(s => observer.observe(s));
  }
  const timer = root.querySelector('[data-timer]');
  if (!timer) return;
  const clock = timer.querySelector('[data-timer-clock]');
  const progress = timer.querySelector('[data-timer-progress]');
  const start = timer.querySelector('[data-timer-start]');
  const reset = timer.querySelector('[data-timer-reset]');
  const status = timer.querySelector('[data-timer-status]');
  const presets = [...timer.querySelectorAll('[data-minutes]')];
  let duration = 30 * 60;
  let remaining = duration;
  let endsAt = 0;
  let interval = 0;
  const draw = () => {
    const seconds = Math.max(0, Math.ceil(remaining));
    clock.textContent = `${Math.floor(seconds / 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
    progress.style.width = `${100 * (1 - remaining / duration)}%`;
  };
  const stop = () => { window.clearInterval(interval); interval = 0; };
  const tick = () => {
    remaining = Math.max(0, (endsAt - Date.now()) / 1000);
    draw();
    if (remaining > 0) return;
    stop(); endsAt = 0;
    start.textContent = labels.start_again;
    status.textContent = labels.done;
    presets.forEach(b => { b.disabled = false; });
  };
  presets.forEach(button => button.addEventListener('click', () => {
    if (interval) return;
    duration = Number(button.dataset.minutes) * 60;
    remaining = duration;
    presets.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    reset.hidden = true;
    start.textContent = labels.start;
    status.textContent = labels.ready;
    draw();
  }));
  start.addEventListener('click', () => {
    if (interval) {
      remaining = Math.max(0, (endsAt - Date.now()) / 1000);
      stop(); endsAt = 0;
      start.textContent = labels.resume;
      status.textContent = labels.paused;
      draw(); return;
    }
    if (remaining <= 0) remaining = duration;
    endsAt = Date.now() + remaining * 1000;
    interval = window.setInterval(tick, 250);
    presets.forEach(b => { b.disabled = true; });
    reset.hidden = false;
    start.textContent = labels.pause_timer;
    status.textContent = labels.running;
    draw();
  });
  reset.addEventListener('click', () => {
    stop(); endsAt = 0; remaining = duration;
    presets.forEach(b => { b.disabled = false; });
    reset.hidden = true;
    start.textContent = labels.start;
    status.textContent = labels.ready;
    draw();
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && interval) tick(); });
})();
